import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

export interface DashboardConfig {
  [role: string]: string[]
}

interface DashboardConfigState {
  config: DashboardConfig
}

const defaultConfig: DashboardConfig = {
  admin: ['my_schedule', 'sales_pipeline', 'outstanding_invoices', 'team_efficiency'],
  manager: ['my_schedule', 'overdue_tasks', 'sales_pipeline', 'team_efficiency'],
  technician: ['my_schedule', 'low_stock'],
  viewer: ['my_schedule'],
}

const safeJsonParse = <T>(value: string | null, fallback: T): T => {
  if (!value || value === 'undefined' || value === 'null') {
    return fallback
  }
  try {
    return JSON.parse(value) as T
  } catch {
    return fallback
  }
}

const storedConfig = localStorage.getItem('dashboardConfig')

const initialState: DashboardConfigState = {
  config: safeJsonParse<DashboardConfig>(storedConfig, defaultConfig),
}

const dashboardConfigSlice = createSlice({
  name: 'dashboardConfig',
  initialState,
  reducers: {
    setRoleModules: (state, action: PayloadAction<{ role: string; modules: string[] }>) => {
      state.config[action.payload.role] = action.payload.modules
      localStorage.setItem('dashboardConfig', JSON.stringify(state.config))
    },
    resetToDefaults: (state) => {
      state.config = defaultConfig
      localStorage.setItem('dashboardConfig', JSON.stringify(defaultConfig))
    },
  },
})

export const { setRoleModules, resetToDefaults } = dashboardConfigSlice.actions
export default dashboardConfigSlice.reducer
